import { useQuery } from 'react-query';
import { queryAllNAF } from './useDomainsList.query';
import { UseDomainsListOptions } from './useDomainsList.types';
// import { AllDomainsResponse } from '../../../types/api/endpoints/consultations/allNAF.types';

export const ALL_NAF_QUERY_KEY = 'ALL_NAF';

export const useDomainsList = (options?: UseDomainsListOptions) => {
  return useQuery<any[], Error>(ALL_NAF_QUERY_KEY, () => queryAllNAF(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
